module.exports = __webpack_public_path__ + "img/DK13884676.432102db.svg";